export class Product{
    public id:string;
    public name:string;
    public description:string;
    public lang:string;
    public avail_languages:Language[];
    public latestVersion:ProductVersion;
    public versions:ProductVersion[];
    public productPackage?:boolean;
    
    constructor(){
      
    }
}

export interface ViewportScrollInformations{
  language: Language;
  themeUrl:string;
  spaceKey:string;
  prodName:string;
  contextPath:string;  
  spaceName:string; 
  isIndex: boolean;
  isSearch:boolean;
  searchType:string;
  searchTerm:string

}

export interface ProductVersion {
 productName?:string;
 productId:string;
 latest:boolean;
 spaceKey:string;
 spaceUrl:string;
 version:string;
 productPackage?:boolean;
 isCurrentVersion?:boolean;
} 

export interface ProductSection{
     id:number;
     name:string;
     description:string;
     productGroups:ProductGroup[];
}

export interface ProductGroup{
  id:number;
  name:string;
  description:string;
  productIds:string[];
}

export interface Relationship{
  parent_node_id:string;
  child_nodes_ids:string[];
}
 
export interface SpaceProperty{
  
    prodId:string,
    prod: string,
    lang: Language,
    productPackage: boolean,
    servicePack:boolean,
    spaceType:string

}
 
export interface RelationshipWithId{
  parent_node_id:string;
  child_nodes_ids:{name:string,id:number}[];
}

export interface SectionRelationship{
  parentNode:ProductSection;
  childNodes:Set<ProductSection>;
}

export interface ProductStructur{
     language:string;
     productAreas:any;
     alphabeticalProducts:any;
     products:any;
     servicePacks:any
}

export interface ProductStructures{
  german:ProductStructur;
  english:ProductStructur;
}

export enum HtmlID{

};

export class Handbook{
    private id:number;
    private parentProduct:Product;
    private immediateParent:any;

    constructor(){

    }
}

export enum ViewPortModus{
  STARTPAGE,
  PRODUCT_SECTION,
  SEARCH,
  NO_VIEWPORT
}


export enum HandbookTyp{
    RELEASE_NOTES,
    USER_GUIDE,
    README_FILE,
    REFERENCE_MANUAL
}

export enum SectionTyp{
    MAIN_CATEGORY,
    PRODUCT_SECTION
}



export enum Region{
    EMEA,
    JAPAN
}

export enum Language{
    DE,
    EN
  }


export interface ManRep{
    list:any[];
    lang:string[];
    region?:string;
}

export interface Viewport{
  id:string,
  spaceKey:string,
  themeName:string,
  viewportUrl:string
}


